import { render, staticRenderFns } from "./TicketDetailModal.vue?vue&type=template&id=4112e77b&"
import script from "./TicketDetailModal.vue?vue&type=script&lang=js&"
export * from "./TicketDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports